import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createExportReportBetsModel } from 'features/export-report-bets';
import { accountTreeModel } from 'entities/account';
import { createBetReportRegistryModel } from 'entities/bet';

const betReportRegistryModel = createBetReportRegistryModel();

const exportReportBetsModel = createExportReportBetsModel(betReportRegistryModel);

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: betReportRegistryModel.registryModel.filters.accountIds.setValue,
});

chain(betReportRegistryModel.registryModel.clearFilters, accountTreeModel.clearSelectedNodes);

export const betsReportPageModel = {
	betReportRegistryModel,
	exportReportBetsModel,
};
